export default {
  components: {
    TaxationIndicatorSimulation: {
      transmittedPatrimony: 'Patrimoine transmis net de fiscalité',
      fiscalCost: 'Coût fiscal de la transmission',
      fiscalPressure: 'Pression fiscale',
    }
  },
}
